import React from 'react'
import { Link } from 'react-router-dom'

const FooterComp = () => {
	return (
		<div id='footer_bar'>
			<div className='top-part'>
				<div className='row gy-4'>
					<div className="col-sm-3">
						<h5>Plan Your Trip</h5>
						<ul>
							<li><Link to="/packages">Packages</Link></li>
							<li><Link to="/destinations">Destination</Link></li>
							<li><Link to="/packages">Holiday Packages</Link></li>
						</ul>
					</div>
					<div className="col-sm-4">
						<h5>Destinations</h5>
						<ul>
							<li>Africa</li>
							<li>Australasia</li>
							<li>Central America</li>
							<li>Europe</li>
							<li>Far East</li>
							<li>Indian Subcontinent</li>
							<li>Middle East & North Africa</li>
							<li>North America</li>
							<li>South America</li>
							<li>Southeast Asia</li>
						</ul>
					</div>
					<div className="col-sm-2">
						
					</div>
					<div className="col-sm-3">
						<h5>Head Office</h5>
						<address>
							5 Coombe Place,<br/>
							Rivonia,<br/>
							Sandton,<br/>
							South Africa, 2128<br/>
						</address>
						<a href="https://maps.app.goo.gl/hg4C7rQWVYUv1gSh7" target="_blank" rel="noopener noreferrer">VIEW MAP <i className='bi bi-arrow-right'></i></a>
					</div>
				</div>
			</div>
			<div className='company-details-container'>
				<ul className='company-details'>
					<li><Link to='/'>Home</Link></li>
					<li><Link to='/contact'>Contact Details</Link></li>
					<li><Link to='/terms-and-conditions'>T&Cs</Link></li>
				</ul>
				<ul className='social-accounts'>
					<li>
						<a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-facebook'></i></a>
					</li>
					<li>
						<a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-instagram'></i></a>
					</li>
					<li>
						<a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-twitter-x'></i></a>
					</li>
					<li>
						<a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-linkedin'></i></a>
					</li>
					<li>
						<a href="http://" target="_blank" rel="noopener noreferrer"><i className='bi bi-tiktok'></i></a>
					</li>
				</ul>
			</div>
			<div className='copyright-part'>
				<p>Copyright &copy; {new Date().getFullYear()} Luxury with Flair (Pty) Ltd. All Rights Reserved.</p>
				<p>Powered by <a href="http://myplusplus.com" target="_blank" rel="noopener noreferrer">mY++</a></p>
			</div>
		</div>
	)
}

export default FooterComp